import { apiClient } from '@/infrastructure/api'
import {
  ReferralsApi,
  ReferralsApiGetReferralsByGroupRequest,
  ReferralsApiPostReferralRequest
} from '@itsrever/rever-api'

const referralsApi = new ReferralsApi(undefined, undefined, apiClient)

async function getReferralsByGroup(
  args: ReferralsApiGetReferralsByGroupRequest,
  signal?: AbortSignal
) {
  const response = await referralsApi.getReferralsByGroup(args, { signal })
  return response.data.referrals
}

async function postReferral(
  args: ReferralsApiPostReferralRequest,
  signal?: AbortSignal
) {
  const response = await referralsApi.postReferral(args, { signal })
  return response.data
}

export default {
  postReferral,
  getReferralsByGroup
}
